<template>
  <v-expansion-panels v-model="computedValue" flat>
    <v-expansion-panel
      class="cfs-expansion-panel connected-content"
      :class="{ 'borderless-content': borderlessContent }"
    >
      <v-expansion-panel-header
        class="cfs-expansion-header"
        :class="{
          expanded: connectedContent,
          left: chevronLeft,
          hazmat: isHazmat,
          '!border-b-0': borderlessHeader,
        }"
        :style="{ 'background-color': headerColor }"
      >
        <template v-if="$hasSlot('label')">
          <slot name="label" />
        </template>
        <template v-else>
          {{ label }}
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content
        class="cfs-expansion-content"
        :class="{ ...contentClasses, connected: connectedContent }"
      >
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Array, Number] as PropType<number[] | number | null>,
      default: null,
    },
    borderlessHeader: {
      type: Boolean,
      default: false,
    },
    bgcolor: {
      type: String,
      default: null,
    },
    headerColor: {
      type: String,
      default: null,
    },
    borderlessContent: {
      type: Boolean,
      default: false,
    },
    connectedContent: {
      type: Boolean,
      default: false,
    },
    chevronLeft: {
      type: Boolean,
      default: true,
    },
    isHazmat: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const contentClasses = computed(() => ({
      [props.bgcolor]: true,
    }));

    const computedValue = computed({
      get() {
        return props.value;
      },
      set(value) {
        return emit('update:value', value);
      },
    });

    return { contentClasses, computedValue };
  },
});
</script>
